export default __webpack_public_path__ + "static/media/holidayMessagePreview.862b22b4.jpg";